"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var Pen = function Pen(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-3 -1 24.5 26.89"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "obzna",
    d: "M16.39,1l5.33,4.64-15.38,18-5,.35L1,19Z",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinejoin: "round",
    fill: "transparent"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "3.18",
    y1: "16.41",
    x2: "8.53",
    y2: "21.03",
    stroke: "currentColor",
    strokeWidth: 1.7
  })))));
};
var _default = exports.default = Pen;